export default __webpack_public_path__ + "static/media/System Dynamics.185d345a.pdf";